import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { APPLY_URL } from '../config';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-16 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
      </div>
      
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Logo and About */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6 group">
              <div className="relative">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-500 group-hover:scale-110">
                  <path d="m8 3 4 8 5-5 5 15H2L8 3z"></path>
                </svg>
              </div>
              <div className="flex flex-col leading-[1.1]">
                <span className="text-sm font-black tracking-[0.15em]">THE SUMMIT</span>
                <span className="text-sm font-black tracking-[0.15em] text-[#FF5722]">ON KING</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium apartments in the heart of Downtown Boone, steps from Appalachian State University.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6 tracking-wide">Quick Links</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/floor-plans" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  Floor Plans
                </Link>
              </li>
              <li>
                <Link to="/amenities" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  Amenities
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#FF5722] transition-all duration-300 hover:translate-x-1 inline-block">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-[#FF5722] flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:8284141040" className="hover:text-[#FF5722] transition-colors">
                    828-414-1040
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-[#FF5722] flex-shrink-0 mt-0.5" />
                <div>
                  <span className="text-sm">
                    400 W King Street &<br />
                    271 Wallace Circle<br />
                    Boone, NC 28607
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Apply */}
          <div>
            <h3 className="font-bold text-lg mb-6 tracking-wide">Ready to Move In?</h3>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              Apply now to secure your spot at Boone's most walkable address.
            </p>
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FF5722] hover:bg-white hover:text-[#FF5722] text-white border-2 border-[#FF5722] font-bold px-6 py-3 rounded-sm transition-all duration-300 hover:shadow-xl hover:-translate-y-1 tracking-wide text-sm"
            >
              APPLY NOW
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm tracking-wide">&copy; {new Date().getFullYear()} The Summit on King. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
